import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutPrincipalComponent } from './layout-principal/layout-principal.component';
import { RouterModule } from '@angular/router';
import { BarraSuperiorComponent } from './barra-superior/barra-superior.component';
import { RodapeComponent } from './rodape/rodape.component';
import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { SharedModule } from '../shared/shared.module';
import { CabecalhoBarraLateralComponent } from './cabecalho-barra-lateral/cabecalho-barra-lateral.component';
import { BotaoScrollComponent } from './botao-scroll/botao-scroll.component';
import { InViewportModule } from 'ng-in-viewport';
import { MapaSiteComponent } from './mapa-site/mapa-site.component';
import { CookiesComponent } from './cookies/cookies.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import {PaginaPrincipalModule} from "../paginas/pagina-principal/pagina-principal.module";
import { TabsModule } from 'primeng/tabs';

@NgModule({
  declarations: [LayoutPrincipalComponent, BarraSuperiorComponent, RodapeComponent, CabecalhoComponent,
    CabecalhoBarraLateralComponent, BotaoScrollComponent, MapaSiteComponent, CookiesComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        InViewportModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        TooltipModule,
        InputTextModule,
        PaginaPrincipalModule,
        TabsModule
    ],
  exports: [LayoutPrincipalComponent, BarraSuperiorComponent, RodapeComponent, CabecalhoComponent]
})
export class LayoutModule { }
